import React from 'react';
import DashboardComponent from '../components/Dashboard';

const Dashboard: React.FC = () => {
  return <DashboardComponent />;
};

export default Dashboard;



